// extracted by mini-css-extract-plugin
export default {"container":"_da37c26a"};